import { createProvider } from 'dreamstate';
import { ReactNode } from 'react';

import { PageProps } from '@vimeo/core/AppTypes';
import { Optional } from '@vimeo/core/types/generic';
import { useScopeGctlProvision } from '@vimeo/live-core/api/base';
import { LiveGlobalsProvider } from '@vimeo/live-core/components/providers/globals';
import { DebugControlManager } from '@vimeo/live-core/store/debug';
import { ModuleManager } from '@vimeo/live-core/store/dependency';
import { InteractionFirebaseManager } from '@vimeo/live-core/store/firebase/base';
import { ChatManager } from '@vimeo/live-core/store/firebase/interaction/chat';
import { PollManager } from '@vimeo/live-core/store/firebase/interaction/poll';
import { QnAManager } from '@vimeo/live-core/store/firebase/interaction/qna';
import { InteractionSessionManager } from '@vimeo/live-core/store/interaction/session';
import { NotificationManager } from '@vimeo/live-core/store/notifications';
import { TrackingManager } from '@vimeo/live-core/store/tracking';
import { IInteractionStoreInitialState } from '@vimeo/live-core/types/store';
import { useScopeViewerProvision } from '@vimeo/live-core/utils/store/viewer';

export const INTERACTION_TOOLS_MANAGERS = [
  DebugControlManager,
  ModuleManager,
  TrackingManager,
  InteractionSessionManager,
  InteractionFirebaseManager,
  NotificationManager,
  ChatManager,
  QnAManager,
  PollManager,
];

const InteractionToolsProviders = createProvider(INTERACTION_TOOLS_MANAGERS);

interface IInteractionToolsProviderProps {
  initialState: IInteractionStoreInitialState;
  pageProps?: Optional<PageProps>;
  children: ReactNode;
}

export function InteractionToolsProvider({
  children,
  initialState,
  pageProps = null,
}: IInteractionToolsProviderProps) {
  useScopeViewerProvision();
  useScopeGctlProvision();

  return (
    <LiveGlobalsProvider initialState={initialState} pageProps={pageProps as unknown as PageProps}>
      <InteractionToolsProviders initialState={initialState}>{children}</InteractionToolsProviders>
    </LiveGlobalsProvider>
  );
}
